/*

https://github.com/themesberg/flowbite-icons

Flowbite Icons is free and open-source under the MIT License.

*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function File({
    className = null,
}: Props) {
    return (
        <svg className={className} width="12" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
            <polyline points="13 2 13 9 20 9" />
        </svg>
    );
}
